// A reusable search class for invoking the typeahead search functionality in several components independently
import ARASearch from '../util/araSearch';
import searchFormHandler from '../util/searchFormHandler';

export default {
  init() {
    /**
     * Prevent send search form with Enter (13) key
    */
    $('form.SearchHero-form').keydown((event) => {
      if (event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });

    /**
     * Responsive mode button for main header menu
     */
    jQuery('.js-hamburger').click(evt => {
      jQuery(evt.currentTarget).toggleClass('is-active')
      jQuery('body').toggleClass('showing-overlay');
    });

    if (jQuery('.js-typeahead').length && jQuery('.js-typeahead-results').length) {

      $.ajax({
        type: 'POST',
        url: window.admin_url.ajax,
        dataType: 'json',
        data: {
          action: 'get_products',
        },
        error(error) {
          console.error(error);
        },
        success(response) {
          const { data: preData } = response;
          const data = JSON.parse(preData);

          if (data[0][0].Key === 'ERROR') {
            alert(data[0][0].Value);
            return;
          }

          /**
           * Typeahead search functionality
           * @author Javier Colmenárez
           * @const {Array}   typeaheadInstances  - Collection of ARASearch instances
           * @const {Array}   states              - Dummy states data **[TO BE REMOVED ONCE INTEGRATED WITH REAL DATA API SERVICE]**
           */
          const typeaheadInstances = [];

          const categories = [];

          data.forEach((val) => {
            categories.push({
              id: val[0].Value,
              name: val[1].Value,
            });
          });

          // Iterating over all of the search input fields and creating the respective configuration objects
          jQuery('.js-typeahead').each((i, elem) => {
            let basicConfig = {
              limit: 10,
              name: 'categories',
              display: 'name',
            };

          /**
           * Search hero components with ARASearch instances
           * @param {Object}      dataConfig  - Specific data configuration to be extended from the ARASearch's internal basic configuration
           *    @prop   {String}  display     - A key name for getting the value to be rendered into the input when the user selects a result.
           *                                    Must be passed only when the data set is an array of objects
           *    @prop   {Number}  limit       - Limit of results to be rendered in the suggestions list, the list is scrollable if needed
           *    @prop   {String}  name        - The dataset name, also used to complete some CSS classes
           * @param {jQuery}      $field      - jQuery element reference to the search input field
           * @param {jQuery}      $results    - jQuery element reference to the results list
           */

            typeaheadInstances.push(new ARASearch({
              dataConfig: basicConfig,
              $field: jQuery(elem),
              $results: jQuery(elem).next('.js-typeahead-results'),
            }));

            /**
             * Initiating the ARASearch instances for the categories & the zones search fields respectively
             * @param {Array||String}     param1  - A dataset reference, either a local array or an URL string to get the data from
             * @param {String||Undefined} param2  - An optional key name to get the items' value to be rendered. Must be passed if dataset is an arrays of objects
             */
            typeaheadInstances[i].init(categories, 'name');

          });
        },
      });
    }
  },
  finalize() {
    jQuery(($) => {
      $(document).ready(()=> {
        searchFormHandler();
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js